import { Cancel } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';

const FilePreview = ({ attachments, handleRemoveImage, submitting }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
            }}>
            {attachments &&
                attachments.map((file, index) => {
                    let fileURL;
                    let fileType;
                    let fileName;

                    if (file instanceof File || file instanceof Blob) {
                        fileURL = URL.createObjectURL(file);
                        fileType = file.type;
                        fileName = file.name;
                    } else if (file && file.url) {
                        fileURL = file.url;
                        fileType = file.content_type || '';
                        fileName = file.file_name || 'file';
                    } else {
                        return null;
                    }

                    const isImage = fileType.startsWith('image');

                    return (
                        <div
                            key={index}
                            style={{
                                position: 'relative',
                                width: '80px',
                                height: '80px',
                                border: '2px solid grey',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxSizing: 'border-box',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#f9f9f9',
                            }}>
                            {isImage ? (
                                <img
                                    src={fileURL}
                                    alt={`file-preview-${index}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#f2f2f2',
                                        borderRadius: '4px',
                                    }}>
                                    <span style={{ fontSize: '12px', color: '#555' }}>
                                        {fileName.split('.').pop().toUpperCase()}
                                    </span>
                                </div>
                            )}

                            <IconButton
                                style={{
                                    position: 'absolute',
                                    top: '8px',
                                    right: '8px',
                                    transform: 'translate(50%, -50%)',
                                    cursor: 'pointer',
                                    color: 'red',
                                    fontSize: '20px',
                                }}
                                disabled={submitting}
                                onClick={() => handleRemoveImage(index)}>
                                <Cancel />
                            </IconButton>
                        </div>
                    );
                })}
        </div>
    );
};

export default FilePreview;
